<template>
  <div class="full-height">
    <div class="fit container-crud q-px-sm">
      <div class="fit">
        <q-card class="fit q-px-sm">
          <q-scroll-area class="container-page-person shadow-1">
            <q-card-section class="q-py-sm">
              <div v-if="nmInterface === 'gravar'" class="crud-title">
                <translate>NEW_REGISTRATION</translate>
              </div>
              <div v-else-if="nmInterface === 'alterar'" class="crud-title">
                <translate>UPDATE</translate> - <translate>REGISTRATION</translate>: {{ unitId }}
              </div>
              <div v-else-if="nmInterface === 'detalhar'" class="crud-title">
                <translate>VIEW_REGISTRATION</translate>
              </div>
            </q-card-section>
            <q-card-section class="q-px-lg container-person row">
              <span v-if="elements.length == 1" class="col-12">
                <q-btn
                  color="grey-3"
                  text-color="primary"
                  icon="description"
                  class="view-button-carrier"
                  flat
                  :label="$gettext('HISTORIC')"
                  @click="openModel"
                  :disabled= "nmInterface === 'gravar' || !flConsumerUnitHistorysExists"
                >
                  <q-tooltip>{{ $gettext('HISTORIC') }}</q-tooltip>
                </q-btn>
                <div class="row q-col-gutter-x-lg q-col-gutter-y-xs">
                  <jt-search-ownership-change
                  v-if="isAlter"
                  :consumerUnitField="ownershipChangeOwner"
                  :label="ownershipChangeOwnerLabel"
                  :consumerUnitData="ownershipChangeFormData"
                  @on-save-ownership="onSaveOwnershipChangeConsumerUnit"
                  />
                  <jt-search-ownership-change
                  v-if="isAlter"
                  :consumerUnitField="ownershipChangeOccupier"
                  :label="ownershipChangeOccupierLabel"
                  :consumerUnitData="ownershipChangeFormData"
                  @on-save-ownership="onSaveOwnershipChangeConsumerUnit"
                  />
                </div>
                <div class="row q-col-gutter-x-lg q-col-gutter-y-xs" style="height:300px">
                <jt-dynamic-form
                    ref="dynamicForm"
                    :inputs="inputs"
                    :relacionamentos="elements[0].relacionamentos"
                    :model="elements[0].dadosForm"
                    :interface="elements[0].nmInterface"
                    form-class="form dynamic"
                  />
                </div>
                <q-dialog v-if="flModal" v-model="flModal" maximized>
                  <q-layout
                    view="Lhh lpR fff"
                    container
                    class="bg-white modal-medium"
                  >
                    <q-header class="bg-primary">
                      <q-toolbar>
                        <q-toolbar-title>{{
                          $gettext('CONSUMER_UNIT_ACTION_HISTORY') + ' ' + elements[0].dadosForm.consumerUnitId
                       }}</q-toolbar-title>
                       <q-btn
                         v-close-popup
                         flat
                         round
                         dense
                         size="1.5em"
                         icon="cancel"
                       />
                      </q-toolbar>
                    </q-header>
                    <q-page-container class="card-container-modal">
                    <crud-layout-search
                      :noneselect="true"
                      :singleselect="false"
                      class="crud-layout-search-detail"
                      ref="crudLayoutSearch"
                      :interface="nmInterfaceHistory"
                      :id="elements[0].dadosForm.consumerUnitId"
                      :params="{consumerUnit: elements[0].dadosForm.consumerUnitId}"
                      clean-layout
                    />
                    </q-page-container>
                  </q-layout>
                </q-dialog>
                <q-dialog v-if="pageDialog.show" v-model="pageDialog.show" maximized>
                  <q-layout
                    view="Lhh lpR fff"
                    container
                    class="bg-white modal-medium"
                  >
                    <q-header class="bg-primary">
                      <q-toolbar>
                        <q-toolbar-title>{{
                          $gettext("VIEW_HISTORIC")
                       }}</q-toolbar-title>
                       <q-btn
                         v-close-popup
                         flat
                         round
                         dense
                         size="1.5em"
                         icon="cancel"
                       />
                      </q-toolbar>
                    </q-header>
                    <q-page-container class="card-container-modal">
                      <page
                        :name="pageDialog.name"
                        :params="pageDialog.params"
                        :forms="pageDialog.forms"
                       />
                    </q-page-container>
                  </q-layout>
                </q-dialog>
              </span>
            </q-card-section>
            <q-card-section style="margin-top: 16vh">
              <q-tabs
                id="jt-compositions"
                v-model="tab"
                align="start"
                color="dark"
                dense

                active-color="primary"
                indicator-color="primary"
              >
                <q-tab
                  v-for="(tab, index) in computedCompositionsTypeElements"
                  :key="index"
                  :name="'xtab-' + index"
                  :label="tab.title || tab.label"
                  :icon="tab.icon"
                  :default="index === 0"
                />
              </q-tabs>
              <q-separator />
              <q-tab-panels v-model="tab" animated>
                <q-tab-panel :key="0" :name="'xtab-0'" keep-alive>
                  <jt-composition
                     v-if="isConsumerUnitAddresss"
                    ref="compositionsAddresss"
                    class="dynamic-compositions"
                    :columns="compositions[0].columns"
                    :data="elements[0].dadosForm.consumerUnitAddresss"
                    :buttons="compositions[0].buttons"
                    :allow-custom-edit-modal="
                      compositions[0].model == 'consumerUnitAddresss'
                    "
                    @on-add="newConsumerUnitAddress"
                    @on-edit="editConsumerUnitAddress"
                    @on-remove="onRemoveConsumerUnitAddressHandler"
                    v-key="compositions[0].model"
                  />
                </q-tab-panel>
                <q-tab-panel :key="1" :name="'xtab-1'" keep-alive>
                  <jt-composition
                    ref="compositionsClient"
                    class="dynamic-compositions"
                    :columns="compositions[1].columns"
                    :data="compositions[1].data"
                    :buttons="compositions[1].buttons"
                    v-key="compositions[1].model"
                    @action-click="onRemoveConsumerUnitClient"
                  />
                </q-tab-panel>
                <q-tab-panel :key="2" :name="'xtab-2'" keep-alive>
                  <jt-composition
                     v-if="isConsumerUnitCategory"
                    ref="compositionCategorys"
                    class="dynamic-compositions"
                    :columns="compositions[2].columns"
                    :data="compositions[2].data"
                    :buttons="compositions[2].buttons"
                    @action-click="editConsumerUnitCategorys"
                    v-key="compositions[2].model"
                  />
                </q-tab-panel>
                <q-tab-panel :key="3" :name="'xtab-3'" keep-alive>
                  <jt-composition
                     v-if="isConsumerUnitFile"
                    ref="compositionsFile"
                    class="dynamic-compositions"
                    :props="props"
                    :columns="compositions[3].columns"
                    :data="compositions[3].data"
                    :buttons="compositions[3].buttons"
                    @action-click="viewConsumerUnitFile"
                    v-key="compositions[3].model"
                  />
                </q-tab-panel>
                <q-tab-panel :key="4" :name="'xtab-4'" keep-alive>
                  <observation-table
                     v-if="isConsumerUnitObservation"
                  :flOpenModal="flModalObservation"
                  :datatable="dataTableObservation"
                  :tableRegister="tableRegistersObservation"
                  :isConsumerUnit="true"
                  @add-observation="addObservation"/>
                </q-tab-panel>
                <q-tab-panel :key="5" :name="'xtab-5'" keep-alive>
                  <jt-composition
                    v-if="compositions[5]"
                    class="dynamic-compositions"
                    :columns="compositions[5].columns"
                    :data="compositions[5].data"
                    :buttons="compositions[5].buttons"
                    @action-click="actionInvoice"
                    v-key="compositions[5].model"
                  />
                </q-tab-panel>
              </q-tab-panels>
            </q-card-section>
          </q-scroll-area>
        </q-card>
      </div>
    </div>
    <div
      class="row full-width q-col-gutter-lg justify-center q-py-lg"
      v-if=" !hiddenButtons && forms[0] && forms[0].buttons.length > 0"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn
          class="full-width"
          color="info"
          @click="actionButton(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <file-viewer-modal
      v-if="showDoc"
      ref="docsModal"
      :buttonName="fileModalButtonName"
      :params="fileModalParams"
      :nmIdentificacaoParserFile="nmIdentificacaoParserFile"
      @close-modal="closeDoc"
    />
    <consumer-unit-address
      v-if="consumerUnitAddressShow"
      ref="consumerUnitAddressModal"
      :form="consumerUnitAddressForm"
      :composicaos="consumerUnitAddressData"
      :nr-linha-selecionada="consumerUnitAddressForm.nrLinhaSelecionada"
      :fl-composicao-alteracao="editMode"
      @onAddSuccess="onAddConsumerUnitAddressSuccessHandler"
      @onEditSuccess="onEditConsumerUnitAddressSuccessHandler"
    />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { repository, messageBox } from 'jtech'
import FileViewerModal from '../../components/file-viewer-modal/FileViewerModal.vue'
import {
  JtCrud,
  JtDynamicForm,
  JtComposition,
  JtCompositions
} from 'jtech-webcomps'
import ServiceObservationController from '../concession/service-request/view/registration-information/service-observation/ServiceObservationController'
import ServiceRequestController from '../concession/service-request/ServiceRequestController'
import { QTab, QTabPanel, QTabPanels } from 'quasar'
import ConsumerUnitAddress from './ConsumerUnitAddress.vue'
import JtSearchOwnershipChange from './JtSearchOwnershipChange.vue'
import ObservationTable from '../concession/service-request/view/registration-information/service-observation/ObservationTable.vue'
import { getInvoiceMonthOrReference } from 'src/shared/global/UtilInvoice'

const { page, CrudLayoutSearch } = JtCrud
import _ from 'lodash'

@Component({
  mixins: [page],
  inject: ['jtdynamicform'],
  name: 'ConsumerUnit',
  components: {
    JtDynamicForm,
    page,
    CrudLayoutSearch,
    JtComposition,
    JtCompositions,
    JtSearchOwnershipChange,
    QTab,
    QTabPanel,
    QTabPanels,
    ConsumerUnitAddress,
    ObservationTable,
    FileViewerModal
  },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    hiddenButtons: { type: Boolean, required: false, default: false },
    parent: Object
  }
})

class ConsumerUnitPage extends Vue {
  serviceObservationController = ServiceObservationController.getInstance();
  serviceRequestController = ServiceRequestController.getInstance();
  getInvoiceMonthOrReference = getInvoiceMonthOrReference;
  flModal = false
  flConsumerUnitHistorysExists = false
  nmInterfaceHistory = 'consumerUnitClientHistoryField.pesquisarHistoryByConsumerUnit'
  historyRows = []
  historyForm = {}
  historyDetailForm = {}
  tab = 'xtab-0'
  nmInterface = null
  interfaceDetails = false
  editMode = false
  isAlter = false
  ownershipChangeOwnerLabel = ''
  ownershipChangeOccupierLabel = ''
  ownershipChangeFormData = {}
  ownershipChangeOwner = null
  ownershipChangeOccupier = null
  consumerUnitAddressForm = {}
  consumerUnitAddressData = []
  consumerUnitAddressShow = false
  icAlterarComposicao = false
  isConsumerUnitObservation = true
  isConsumerUnitFile = true
  isConsumerUnitCategory = true
  isConsumerUnitAddresss = true
  showDoc = false
  src = null
  flModalObservation = false
  dataTableObservation = null
  tableRegistersObservation = { registros: [] }
  nmIdentificacaoParserFile = 'CONSUMER_UNIT_FILE'
  fileModalButtonName = ''
  fileModalParams = {}
  pageDialog = {
    name: 'label',
    show: false
  }

  mounted () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
    this._hiddenRowMouseoverHandler = (event) => {
      const div = event.target && event.target.closest && event.target.closest('.hidden-row > div')
      if (!div) return
      if (div.scrollWidth > div.clientWidth + 1) {
        div.title = div.textContent.trim()
      } else {
        div.removeAttribute('title')
      }
    }
    document.body.addEventListener('mouseover', this._hiddenRowMouseoverHandler)
    this.changeQuantityByCategorys(this.consumerUnitCategorys)
    if (this.nmInterface === 'alterar') {
      this.isAlter = true
      const dadosForm = this.elements[0].dadosForm
      this.ownershipChangeOwnerLabel = this.$gettext('OWNER')
      this.ownershipChangeOccupierLabel = this.$gettext('OCCUPIER')
      this.ownershipChangeFormData = {
        consumerUnitClients: dadosForm.consumerUnitClients,
        newOwner: dadosForm.consumerUnitOwner,
        newOccupier: dadosForm.consumerUnitOccupier,
        oldOwner: dadosForm.consumerUnitOwner,
        oldOccupier: dadosForm.consumerUnitOccupier
      }
      this.ownershipChangeOwner = dadosForm.consumerUnitOwner
      this.ownershipChangeOccupier = dadosForm.consumerUnitOccupier
    }
    if (this.nmInterface !== 'gravar') { // ← guarda adicionada
      this.consumerUnitHistorysExists()
    }
    const consumerUnitPerson = this.elements[0].inputs.find((input) =>
      (input.model == 'consumerUnitOwner') ||
      (input.model == 'consumerUnitOccupier') ||
      (input.model == 'consumerUnitInterested'))
    if (consumerUnitPerson) { consumerUnitPerson.type = 'person_search' }
  }

  async actionButtonHistory (button, params) {
    const detailForm = await repository.resolve('consumerUnitClientHistory.detalhar')
    this.historyDetailForm = detailForm
  }

  onSaveOwnershipChangeConsumerUnit (data) {
    if (data.datesData.dateRegisterType != 50020002) {
      this.ownershipChangeOwner = data.occupierAndOwnerData.newOwner
      this.ownershipChangeOccupier = data.occupierAndOwnerData.newOccupier
      this.elements[0].dadosForm.consumerUnitOwner = data.occupierAndOwnerData.newOwner
      this.elements[0].dadosForm.consumerUnitOccupier = data.occupierAndOwnerData.newOccupier
    }
    const ownershipChangeData = []
    ownershipChangeData.push(data.filesData)
    ownershipChangeData.push(data.datesData)
    ownershipChangeData.push(data.occupierAndOwnerData)
    this.elements[0].dadosForm.ownershipChangeData = ownershipChangeData
  }

  @Watch('consumerUnitCategorys', { deep: true })
  onChangeConsumerUnitCategorys () {
    this.changeQuantityByCategorys(this.consumerUnitCategorys)
  }

  @Watch('tab')
  async onTabChange (value, oldValue) {
    if (value === 'xtab-4') {
      const datatables = await this.serviceObservationController.loadDatatable()
      this.dataTableObservation = datatables
      this.loadServiceObservations()
    }
  }

  async loadServiceObservations () {
    const registros =
    await this.serviceObservationController.loadDatatableModel({ consumerUnit: this.elements[0].dadosForm.consumerUnitId })
    this.tableRegistersObservation = registros
  }

  get consumerUnitCategorys () {
    return this.elements[0]?.dadosForm?.consumerUnitCategorys || []
  }

  editConsumerUnitCategorys (data) {
    if (data.button.name == 'icAlterarComposicao') {
      this.icAlterarComposicao = true
    } else if (data.button.name == 'btSalvarComposicao') {
      this.isConsumerUnitCategory = false
      if (this.icAlterarComposicao) {
        this.icAlterarComposicao = false
      }
      this.$nextTick(() => {
        this.isConsumerUnitCategory = true
        this.changeQuantityByCategorys(this.consumerUnitCategorys)
      })
    }
    this.changeQuantityByCategorys(this.consumerUnitCategorys)
  }

  changeQuantityByCategorys (composition) {
    let sumQtd = 0
    composition.forEach((row) => {
      sumQtd = sumQtd + row.quantity
    })

    this.$nextTick(() => {
      this.$set(this.elements[0].dadosForm, 'quantity', sumQtd)
    })
  }

  get inputs () {
    return this.elements[0].inputs.filter(
      (ci) => ci.type !== 'COMPOSICAO'
    )
  }

  addObservation (note) {
    this.isConsumerUnitObservation = false
    this.elements[0].dadosForm.consumerUnitMemos.push({
      consumerUnit: this.elements[0].dadosForm.consumerUnitId,
      ...note
    })
    this.flModalObservation = false
    this.$nextTick(() => {
      this.isConsumerUnitObservation = true
    })
  }

  closeObservationModal () {
    this.flModalObservation = false
  }

  async openModel () {
    this.flModal = true
  }

  beforeDestroy () {
    if (this._hiddenRowMouseoverHandler) {
      document.body.removeEventListener('mouseover', this._hiddenRowMouseoverHandler)
      this._hiddenRowMouseoverHandler = null
    }
  }

  async consumerUnitHistorysExists () {
    const { registros } = await repository.resolveDatatableModel(
      'consumerUnitClientHistoryField.pesquisarHistoryByConsumerUnit',
      { consumerUnit: this.elements[0].dadosForm.consumerUnitId }
    )
    if (registros.length > 0) {
      this.flConsumerUnitHistorysExists = true
      this.historyRows = registros
      this.historyForm = await repository.resolve('consumerUnitClientHistoryField.pesquisarHistoryByConsumerUnit')
    }
  }

  formateInputsArray () {
    return _.chain(this.elements[0].inputs)
      .orderBy((input) => input.type === 'COMPOSICAO', ['asc'])
      .groupBy((input) =>
        input.type === 'COMPOSICAO' ? 'composition' : 'input'
      )
      .toPairs()
      .map((item) => _.zipObject(['type', 'elements'], item))
      .value()
  }

  newConsumerUnitAddress (data) {
    this.editMode = false
    this.openConsumerUnitAddress(data)
  }

  editConsumerUnitAddress (data) {
    this.editMode = true
    this.openConsumerUnitAddress(data)
  }

  get unitId () {
    return this.params?.id || this.elements[0]?.dadosForm?.consumerUnitId || ''
  }

  onRemoveConsumerUnitAddressHandler (index) {
    this.elements[0].dadosForm.consumerUnitAddresss.splice(index, 1)
  }

  onRemoveConsumerUnitClient (data) {
    if (this.elements[0].dadosForm.consumerUnitClients[data.params.__index].available === false) {
      this.elements[0].dadosForm.consumerUnitClients.splice(data.params.__index, 1)
    } else {
      messageBox.warn(this.$gettext('REMOVE_ACTIVE_CLIENT_FROM_CONSUMER_UNIT'))
    }
    this.$nextTick(() => {
      this.$refs.compositionsClient.$forceUpdate()
    })
  }

  openConsumerUnitAddress (data) {
    this.consumerUnitAddressShow = true
    this.consumerUnitAddressForm = { ...data }
    this.consumerUnitAddressData = this.elements[0].dadosForm.consumerUnitAddresss
    this.$nextTick(() => {
      this.$refs.consumerUnitAddressModal.show()
    })
  }

  onAddConsumerUnitAddressSuccessHandler (dados) {
    try {
      this.elements[0].dadosForm.consumerUnitAddresss.push(dados)
      this.$refs.consumerUnitAddressModal.hide()
      this.consumerUnitAddressShow = true
      this.isConsumerUnitAddresss = false
      this.$nextTick(() => {
        this.isConsumerUnitAddresss = true
      })
    } catch (error) {
      console.error('onAddConsumerUnitAddressSuccessHandler', error)
    }
  }

  onEditConsumerUnitAddressSuccessHandler (dados) {
    try {
      const index = dados.nrLinhaSelecionada
      Object.assign(this.elements[0].dadosForm.consumerUnitAddresss[index], dados)
      this.$refs.consumerUnitAddressModal.hide()
      this.consumerUnitAddressShow = true
    } catch (error) {
      console.error('onEditConsumerUnitAddressSuccessHandler', error)
    }
  }

  get compositions () {
    return this.computedCompositionsTypeElements
  }

  get computedCompositionsTypeElements () {
    const compositions = this.formateInputsArray()
    return (
      _.chain(compositions)
        .find((ci) => ci.type === 'composition')
        .get('elements')
        .map((e) => {
          e.data = this.elements[0].dadosForm[e.model]
          e.uuid = 'id'
          if (e.model === 'invoices' && Array.isArray(this.elements[0].dadosForm[e.model])) {
            e.data = this.elements[0].dadosForm[e.model].map(invoice => ({
              ...invoice,
              reference: this.getInvoiceMonthOrReference(invoice)
            }))
          } else {
            e.data = this.elements[0].dadosForm[e.model]
          }
          e.columns.map((col) => {
            col.name = col.name || col.model
            col.field = col.name
            col.sortable = true
            col.align = 'left'
            return col
          })
          if (e.model === 'consumerUnitAddresss') {
            e.allowCustomEditModal = true
          }
          return e
        })
        .value() ?? []
    )
  }

  isValid () {
    return this.$refs.compositionsAddresss.isValid()
  }

  limparForm () {
    Array.isArray(this.$refs.dynamicForm)
      ? this.$refs.dynamicForm[0].resetForm()
      : this.$refs.dynamicForm.resetForm()
    this.elements[0].dadosForm.consumerUnitAddresss = []
    this.elements[0].dadosForm.consumerUnitClients = []
    this.elements[0].dadosForm.consumerUnitCategorys = []
    this.elements[0].dadosForm.consumerUnitFiles = []
    this.elements[0].dadosForm.consumerUnitMemos = []
    this.flConsumerUnitHistorysExists = false
    this.changeQuantityByCategorys(this.consumerUnitCategorys)
  }

  get consumerUnitAddresssXX () {
    return this.elements[0].dadosForm.consumerUnitAddresss
  }

  async actionInvoice ({ button, params }) {
    const forms = await repository.resolve(button.action, { id: params.id })
    this.pageDialog = {
      name: 'label',
      params: params,
      forms: forms,
      show: true
    }
  }

  viewConsumerUnitFile ({ button, params }) {
    if (button.name == 'icDetalharArquivo' ||
        button.name == 'icDownload') {
      if (params.available) {
        this.fileModalButtonName = button.name
        this.fileModalParams = params
        this.showDoc = true
      } else {
        messageBox.warn(this.$gettext('INACTIVE_ATTACHMENT'))
      }
    } else if (button.name == 'btSalvarComposicao') {
      this.isConsumerUnitFile = false
      this.$nextTick(() => {
        this.isConsumerUnitFile = true
      })
    }
  }

  closeDoc () {
    this.showDoc = false
  }
}
export default ConsumerUnitPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.crud-layout-search-detail {
  ::v-deep {
    .jt-crud-container .justify-end  {
      padding: 0%;
      display: none !important;
      border: 1px solid red !important;
    }
    .q-table--col-auto-width {
      display: none !important;
    }
    .hidden-row {
      max-height: 160px;
      overflow-y: auto;

      > div {
        flex: 0 0 20% !important;
        max-width: 20% !important;
        width: 20% !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        box-sizing: border-box;
        padding-right: 8px;
        cursor: default;
      }
    }
  }
}

.text-sub {
  font-size: 0.8rem;
}
.dynamic-compositions {
  .hidden-row > div {
    width: 100%;
    padding: 5px 12px;
  }

  .hidden-row > div:nth-child(odd) {
    background-color: $grey-3;
  }

  .q-table--no-wrap td {
    white-space: inherit !important;
  }
}

.q-td {
  white-space: none;
}

.container-page-person{
  height: calc(79vh - 0px);
}

.container-person {
 .dynamic-compositions{
    .dynamic-form #scroll-area {
    height: calc(60vh - 12px)!important;
  }
 }
}

.view-button-carrier {
  position: absolute;
  top: -46px;
  right: 14px;
  border-radius: 5px;
}

@media only screen and (max-height: 880px) {
  .container-person {
    .dynamic-form #scroll-area {
      height: calc(48vh - 12px) !important;
    }

  ..addressPersonForms{
    .dynamic-form #scroll-area {
      height: calc(66vh - 12px) !important;
      }
    }
  }
}

@media only screen and (max-height: 800px) {
  .container-person {
    .dynamic-form #scroll-area {
      height: calc(50vh - 12px) !important;
    }
  }
}

@media only screen and (max-height: 760px) {
  .container-page-person{
    height: calc(75vh - 0px);
  }

  .container-person {
    .dynamic-form #scroll-area {
      height: calc(53vh - 12px) !important;
    }
  }
}

@media only screen and (max-height: 710px) {
  .container-person {
  .dynamic-form #scroll-area {
    height: calc(58vh - 12px) !important;
    }
  }
}

</style>
